
import Vue from 'vue'
import { searchSuggestion } from '../store/actions';
import { ITranslations } from '../store/state';

interface HitCountComputed {
	totalHits: number
    showingHits: number
    hitCountText: string
    suggestion?: string
    translations: ITranslations
}
interface HitCountMethods {
    searchSuggestion(suggestion: string): void
}

export default Vue.extend<{}, HitCountMethods, HitCountComputed, {}>({
	name: 'HitCount',
	computed: {
		totalHits() {
            return this.$store.getters.totalHits;
        },
        showingHits() {
            return this.$store.getters.showingHits;
        },
        hitCountText() {
            const totalHits = this.$store.getters.totalHits;
            return totalHits > 1 ? 
                `${this.translations.weFound} <strong>${totalHits} ${this.translations.hits}</strong> ${this.translations.matchingYourQuery}` :
                `${this.translations.weFound} <strong>${totalHits} ${this.translations.hit}</strong> ${this.translations.matchingYourQuery}`
        },
        suggestion() {
            return this.$store.getters.suggestion;
        },
        translations() {
            return this.$store.getters.translations;
        }
	},
    methods: {
        searchSuggestion(suggestion) {
            this.$store.dispatch(searchSuggestion(suggestion))
        }
    }
})
